import { Form } from '@/components';
import styled from 'styled-components';

export const StyledForm = styled(Form)`
  width: 100%;
  height: 100%;
  gap: 1rem;
`;
